import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const ShariPage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  return (
    <Layout location={props.location}>
      <Helmet>
        <html className="memberpage" lang="da" />
      </Helmet>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <div className="space-8"></div>

            <div className="grid">
              <div className="member-2col-left">
                <div className="member-inner">
                  <h1>Nicola Menge</h1>
                  <h3>Professional</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Date of employment at Emento
                      </div>
                      <div class="flex-row" role="cell">
                        April 2023
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Title
                      </div>
                      <div class="flex-row" role="cell">
                        Project Manager eHealth
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Responsibilities
                      </div>
                      <div class="flex-row" role="cell">
                        Tender Management, Introduction CRM, Marketing
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Educational background
                      </div>
                      <div class="flex-row" role="cell">
                        Translator and Interpreter for English and French,
                        International Business Coordinator (International
                        Management, Foreign language correspondent for Chinese)
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Previous positions/industries
                      </div>
                      <div class="flex-row" role="cell">
                        International Project and Product Manager (medical
                        software), Project Manager Digital Media (structure,
                        design and content for the websites of different trade
                        shows)
                      </div>
                    </div>
                  </div>
                  <h3>Personal</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Bucket list no. 1
                      </div>
                      <div class="flex-row" role="cell">
                        Travel the USA for at least 3 months
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Favorite music
                      </div>
                      <div class="flex-row" role="cell">
                        The Dead South (and generally Hard Rock, Punk Rock,
                        Classic Rock, Bluegrass)
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Biggest food or drink consumption
                      </div>
                      <div class="flex-row" role="cell">
                        Food: Seafood, Cheese / Drink: Coffee, Sparkling Wine
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Best TV series
                      </div>
                      <div class="flex-row" role="cell">
                        Friends, The Witcher, Umbrella Academy, Lord of the
                        Rings
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Extraordinary skill
                      </div>
                      <div class="flex-row" role="cell">
                        Cooking, tying knots in cherry stems only using my
                        tongue
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Preferred traveling style
                      </div>
                      <div class="flex-row" role="cell">
                        Roadtrip by car with good music
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        My friends recognizes me for
                      </div>
                      <div class="flex-row" role="cell">
                        loyal, reliable, helpful
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        As a kid, I wanted to become
                      </div>
                      <div class="flex-row" role="cell">
                        Teacher or Veterinarian
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Social links
                      </div>
                      <div class="flex-row" role="cell">
                        <Link
                          to="https://www.linkedin.com/in/nicolamenge/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          LinkedIn
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-middle">
                <div className="member-hero-inner">
                  <div className="member-hero-box">
                    <div className="member-hero-image">
                      <img
                        src="/images/portraits/internal/nicola_hero.jpg"
                        alt=""
                      />
                    </div>
                    <h3>Feels like: Groot</h3>
                    Strength
                    <div className="full-bar">
                      <div className="bar size-60" />
                    </div>
                    Artistic
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Spontaneous
                    <div className="full-bar">
                      <div className="bar size-40" />
                    </div>
                    Determined
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Polite
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Playful
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Empathy
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Intelligence
                    <div className="full-bar">
                      <div className="bar size-60" />
                    </div>
                    Brave
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-right">
                <div className="member-childhood-inner">
                  <div
                    className="member-childhood-image"
                    style={{
                      backgroundImage: `url(/images/portraits/internal/nicola_child.jpg)`,
                    }}
                  >
                    <div className="blur-bg">
                      <img
                        src="/images/portraits/internal/nicola_child.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ShariPage
